export default {
  computed: {
    porcentagemRespostasPsicossocial() {
      const respostas = this.$store.state.avaliacaoPsicossocial.respostas
      const perguntas = this.$store.state.avaliacaoPsicossocial.perguntas

      if (!perguntas || perguntas.length === 0) return 0

      const perguntasPreenchidas = Object.values(respostas).filter(resposta => {
        if (!resposta || resposta.value == null) return false

        const valor = resposta.value

        if (typeof valor === 'string') return valor.trim() !== ''

        if (typeof valor === 'object') {
          if (Array.isArray(valor)) return valor.length > 0
          return typeof valor.value === 'string' && valor.value.trim() !== ''
        }

        return false
      }).length

      return Math.round((perguntasPreenchidas / perguntas.length) * 100)
    }
  }
}
